module.exports = __webpack_public_path__ + "img/up.5e9676de.svg";